export default function useIsMas() {
  const { isMas } = useTenantConfig()
  return isMas
}
